document.addEventListener('DOMContentLoaded', () => {
  initAboutValues();

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.about-values')) {
      initAboutValues();
    }
  });
});

function initAboutValues() {
  const sections = document.querySelectorAll('.about-values');

  sections.forEach((section) => {
    initAboutValuesMobile(section);

    if (window.matchMedia('(max-width: 1024px)').matches) return;
    if (section.dataset.aboutValuesDesktopInitialized === 'true') return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    const scrollContainer = section.querySelector('.about-values__scroll-container');
    const bgImages = section.querySelectorAll('.about-values__bg-image');
    const cards = section.querySelectorAll('.about-values__card');
    const leftContent = section.querySelector('.about-values__left');
    const blockCount = cards.length;

    if (blockCount === 0) return;

    section.dataset.aboutValuesDesktopInitialized = 'true';

    const stickyEl = section.querySelector('.about-values__sticky');
    const stickyHeight = stickyEl.offsetHeight;
    scrollContainer.style.height = (stickyHeight * blockCount) + 'px';

    let isVisible = false;
    let currentIndex = -1;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isVisible = entry.isIntersecting;
        });
      },
      { threshold: 0 }
    );

    observer.observe(scrollContainer);

    setActive(0);

    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!isVisible) return;
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        const rect = scrollContainer.getBoundingClientRect();
        const scrolled = -rect.top;
        const totalScrollable = scrollContainer.offsetHeight - window.innerHeight;

        if (totalScrollable <= 0) {
          ticking = false;
          return;
        }

        const progress = Math.max(0, Math.min(1, scrolled / totalScrollable));
        const index = Math.min(blockCount - 1, Math.floor(progress * blockCount));

        if (index !== currentIndex) {
          setActive(index);
          currentIndex = index;
        }

        ticking = false;
      });
    });

    function setActive(index) {
      if (index === currentIndex) return;
      currentIndex = index;
      bgImages.forEach((img, i) => {
        img.classList.toggle('is-active', i === index);
      });
      cards.forEach((card, i) => {
        card.classList.toggle('is-active', i === index);
      });
      if (leftContent) {
        leftContent.classList.toggle('is-hidden', index !== 0);
      }
    }
  });
}

function initAboutValuesMobile(section) {
  if (section.dataset.aboutValuesMobileInitialized === 'true') return;

  const slides = section.querySelector('.about-values__slides');
  const slideItems = section.querySelectorAll('.about-values__slide');
  const dots = section.querySelectorAll('.about-values__pagination-dot');

  if (!slides || slideItems.length === 0 || dots.length === 0) return;

  section.dataset.aboutValuesMobileInitialized = 'true';

  let currentIndex = -1;
  let ticking = false;

  setMobileActive(0);

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = Number(dot.dataset.aboutValuesSlide);
      const slide = slideItems[index];

      if (!slide) return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      slides.scrollTo({
        left: slide.offsetLeft - slides.offsetLeft,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });

      setMobileActive(index);
    });
  });

  slides.addEventListener('scroll', () => {
    if (ticking) return;

    ticking = true;
    requestAnimationFrame(() => {
      const index = getClosestSlideIndex();
      setMobileActive(index);
      ticking = false;
    });
  }, { passive: true });

  function getClosestSlideIndex() {
    let closestIndex = 0;
    let closestDistance = Infinity;

    slideItems.forEach((slide, index) => {
      const distance = Math.abs(slides.scrollLeft - (slide.offsetLeft - slides.offsetLeft));

      if (distance < closestDistance) {
        closestIndex = index;
        closestDistance = distance;
      }
    });

    return closestIndex;
  }

  function setMobileActive(index) {
    if (index === currentIndex) return;

    currentIndex = index;

    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;

      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }
}
